import CityPropertyApi from "../../services/api/CityProperty";
import GenSettingApi from "../../services/api/GenSetting";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";
import qs from "qs";

function handleError(err) {
  console.log("error in change logs actions:", err);
}

export const SetCityPropertyChangeLog = (payload) => {
  return {
    type: ActionTypes.SET_CITY_PROPERTY_CHANGE_LOG,
    payload,
  };
};

export const SetGenSettingChangeLog = (payload) => {
  return {
    type: ActionTypes.SET_GEN_SETTING_CHANGE_LOG,
    payload,
  };
};

export const SetActiveFilterChangeLog = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS_CHANGE_LOG,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_CHANGE_LOG,
    payload,
  };
};

export const SetPropertyKeys = (payload) => {
  return {
    type: ActionTypes.SET_PROPERTY_KEYS,
    payload,
  };
};

export const getCityPropertyChangeLog =
  (filters = {}, pageRequest = {}, id) =>
  async (dispatch) => {
    try {
      let finalPayload = {
        ...pageRequest,
      };
      if (Object.keys(filters).length > 0) {
        Object.keys(filters).forEach((key) => {
          const filterKey = key;
          finalPayload[filterKey] = filters[key];
        });
      }
      const queryParams = qs.stringify(finalPayload, { addQueryPrefix: true });
      dispatch(setLoader(true));
      let response = await CityPropertyApi.getCityPropertyChangeLog(
        queryParams,
        id
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(SetCityPropertyChangeLog(response));
        return response;
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getGenSettingChangeLog =
  (filters = {}, pageRequest = {}) =>
  async (dispatch) => {
    try {
      let finalPayload = {
        ...pageRequest,
      };

      if (Object.keys(filters).length > 0) {
        Object.keys(filters).forEach((key) => {
          const filterKey = key;
          finalPayload[filterKey] = filters[key];
        });
      }
      const queryParams = qs.stringify(finalPayload, { addQueryPrefix: true });
      dispatch(setLoader(true));
      let response = await GenSettingApi.getGenSettingChangeLog(queryParams);
      dispatch(setLoader(false));
      if (response) {
        dispatch(SetGenSettingChangeLog(response));
        return response;
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getGenSettingKeys =
  (filters = {}, pageRequest = {}) =>
  async (dispatch) => {
    try {
      let finalPayload = {
        ...pageRequest,
      };
      if (filters.hasOwnProperty("key") && filters["key"] === "") {
        delete filters.key;
      }
      if (Object.keys(filters).length > 0) {
        Object.keys(filters).forEach((key) => {
          const filterKey = key;
          finalPayload[filterKey] = filters[key];
        });
      }
      const queryParams = qs.stringify(finalPayload, { addQueryPrefix: true });
      dispatch(setLoader(true));
      let response = await GenSettingApi.getGenSettingKeys(queryParams);
      dispatch(setLoader(false));
      if (response) {
        dispatch(SetPropertyKeys(response));
        return response;
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getCityPropertyKeys =
  (filters = {}, pageRequest = {}) =>
  async (dispatch) => {
    let id = "";
    if (filters.id) {
      id = filters.id;
      delete filters.id;
    }
    if (filters.hasOwnProperty("key") && filters["key"] === "") {
      delete filters.key;
    }
    try {
      let finalPayload = {
        ...pageRequest,
      };
      if (Object.keys(filters).length > 0) {
        Object.keys(filters).forEach((key) => {
          const filterKey = key;
          finalPayload[filterKey] = filters[key];
        });
      }

      const queryParams = qs.stringify(finalPayload, { addQueryPrefix: true });
      dispatch(setLoader(true));
      let response = await CityPropertyApi.getCityPropKeys(
        queryParams,
        parseInt(id)
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(SetPropertyKeys(response));
        return response;
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };
